if (!customElements.get('pet-photo-check')) {
  customElements.define(
    'pet-photo-check',
    class PetPhotoCheck extends HTMLElement {
      connectedCallback() {
        this.states = JSON.parse(this.querySelector('[data-check-states]').textContent);
        this.boxes = [...this.querySelectorAll('[data-check]')];
        this.titleEl = this.querySelector('[data-check-title]');
        this.textEl = this.querySelector('[data-check-text]');
        this.boxes.forEach((box) => box.addEventListener('change', () => this.update()));
      }

      update() {
        const ticked = this.boxes.filter((box) => box.checked).length;
        let state = this.states.some;
        if (ticked === 0) state = this.states.none;
        if (ticked === this.boxes.length) state = this.states.all;
        this.titleEl.textContent = state.title;
        this.textEl.textContent = state.text;
      }
    }
  );
}
